(function($) {

  $(document).ready(function() {
    if ( $('body[class*="template-aboutus-timeline"]').length > 0 ) {
      buildAnchors();
      setupFade();
      setupClickToScroll();
      setupPostAnimation();
      setupScrollToTop();
      enableScrollAbortion();

      // Trigger window.scroll, this will initiate some of the scripts
      $(window).scroll();
    }
  });

  function buildAnchors() {
    let dates = $('#timeline-column .section.main-content article.post .post-content > h2.post-date');
    let posts = $('#timeline-column .section.main-content article.post');
    let dateList = $('#timeline-selector-list');
    $.each(posts, function () {
      $(this).attr('id', this.childNodes[1].childNodes[5].childNodes[1].innerText + '-anchor');
    });
    $.each(dates, function (key, value) {
      dateList.append('<li><a class="timeline-link" id="' + value.innerText + '-link">' + value.innerText + '</a></li>');
    });
  }

  // Allow user to cancel scroll animation by manually scrolling
  function enableScrollAbortion() {
    var $viewport = $('html, body');
    $viewport.on('scroll mousedown DOMMouseScroll mousewheel keyup', function(e) {
      if ( e.which > 0 || e.type === 'mousedown' || e.type === 'mousewheel') {
        $viewport.stop();
      }
    });
  }

  function setupScrollToTop() {
    var scrollSpeed = 750;
    $('.trigger-scroll-to-top').click(function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0,
      }, scrollSpeed);
    });
  }


  function setupPostAnimation() {
    var posts = $('.post-wrapper .post');
    $(window).on('scroll resize', function() {

      var currScroll = $(window).scrollTop() > $(document).scrollTop() ? $(window).scrollTop() : $(document).scrollTop(),
        windowHeight = $(window).height(), // Needs to be here because window can resize
        overScroll = Math.ceil(windowHeight*.20),
        treshhold = (currScroll + windowHeight) - overScroll;

      posts.each(function() {

        var post = $(this),
          postScroll = post.offset().top;

        if(postScroll > treshhold) {
          post.addClass('hidden');
        } else {
          post.removeClass('hidden');
        }

      });

    });
  }

  function setupFade() {

    var posts = $('.post-wrapper .post').reverse(),
      halfScreen = $(window).height() / 2;


    $(window).on('scroll resize', function() {

      var currScroll = $(window).scrollTop() > $(document).scrollTop() ? $(window).scrollTop() : $(document).scrollTop(),
        scrollSplit = currScroll + halfScreen;


      delay(function() {

        var desktopNavHeight = $('#desktop-nav').is(':visible') ? $('#desktop-nav').height() : 0;
        var mobileNavHeight = $('#nav-logo').is(':visible') ? $('#nav-logo').height() : 0;
        var mobileSectionNavHeight = $('#mobile-section-nav').is(':visible') ? $('#mobile-section-nav').height() : 0;
        var navHeight = desktopNavHeight + mobileNavHeight + mobileSectionNavHeight;
        var stem = $('#stem');
        var firstPoint = $('.timeline-point', posts[posts.length - 1]);
        var lastPoint = $('.timeline-point', posts[0]);

        var postHeight = lastPoint.offset().top - firstPoint.offset().top;

        stem.height((1 / (postHeight / currScroll) * postHeight) + 350);

        stem.css('top', firstPoint.offset().top - navHeight);

        // var lastPoint = $('.timeline-point', posts[0]);
        // var lastPointOffset = lastPoint.offset().top;

        $('.timeline-point').each(function() {
          var point = $(this),
            pointOffset = point.offset().top + navHeight;

          if (scrollSplit > pointOffset) {
            point.css('border', '2px solid #0154A0');
          }
          else {
            point.css('border', '2px solid #646464');
          }
        });

        posts.removeClass('active').each(function() {

          var post = $(this),
            postOffset = post.offset().top;

          if(scrollSplit > postOffset) {

            // Add active class to fade in
            post.addClass('active');

            return false;
          }

        });
      }, 10);

    });

  }


  function setupClickToScroll() {
    var scrollSpeed = 250;

    $('.timeline-link').on('click', function(e) {
      e.preventDefault();

      var currScroll = $(window).scrollTop() > $(document).scrollTop() ? $(window).scrollTop() : $(document).scrollTop();
      var desktopNavHeight = $('#desktop-nav').is(':visible') ? $('#desktop-nav').height() : 0;
      var mobileNavHeight = $('#nav-logo').is(':visible') ? $('#nav-logo').height() : 0;
      var mobileSectionNavHeight = $('#mobile-section-nav').is(':visible') ? $('#mobile-section-nav').height() : 0;
      var navHeight = desktopNavHeight + mobileNavHeight + mobileSectionNavHeight;
      var link = $(this);
      var linkId = String(link[0].id);
      var year = linkId.substring(0, linkId.length - 5);
      var postId = String(year + '-anchor');
      var postSelector = 'article[id="' + postId + '"]';
      var post = $(postSelector);
      var postTopOffset = post.offset().top;
      // var postHeight = post.height();
      // var halfScreen = $(window).height() / 2;
      var scrollTo = postTopOffset - navHeight;
      if (currScroll < postTopOffset) {
        scrollTo -= 200;
      }

      $('html, body').animate({
        scrollTop: scrollTo,
      }, scrollSpeed);
    });

  }

})(jQuery);




/*==========  Helpers  ==========*/


// Timeout function
var delay = (function(){
  var timer = 0;
  return function(callback, ms){
    clearTimeout (timer);
    timer = setTimeout(callback, ms);
  };
})();

$.fn.reverse = function() {
  return this.pushStack(this.get().reverse(), arguments);
};



// WEBPACK FOOTER //
// ./scripts/timeline.js